import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { OrderThisMonthTitle } from "../../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { SalesReportsLineChart } from "../../../../../Data/General/Dashboard/ECommerce";

const OrderThisMonthTwo = () => {
  return (
    <Col xl="5" md="6">
      <Card>
        <DashboardCommonHeader title={OrderThisMonthTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div id="salesReportsLineChart">
            <ReactApexChart options={SalesReportsLineChart} series={SalesReportsLineChart.series} height={290} type="line" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderThisMonthTwo;
